<div class="main-layout">
  <app-side-menu></app-side-menu>
  <div class="frame">
    <div class="content-area">
      <router-outlet></router-outlet>
      <!-- Nested routes will be rendered here -->
    </div>
  </div>
</div>